import React, { useState } from "react";

const TableHead = ({ columns, handleSorting }) => {
  const [sortCol, setSortCol] = useState("");
  const [order, setOrder] = useState("asc");
  const handleColSort = accessor => {
    const sortOrder = accessor === sortCol && order === "asc" ? "desc" : "asc";
    setSortCol(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  };
  return (
    <thead className="ui table head row">
      <tr>
        {columns.map(({ label, accessor, sortable }) => {
          const sortDir = sortable
            ? sortCol === accessor && order === "asc"
              ? "up"
              : sortCol === accessor && order === "desc" ? "down" : ""
            : "";
          return (
            <th
              className="ui head cell"
              key={accessor}
              onClick={sortable ? () => handleColSort(accessor) : null}
            >
              <i key={accessor} className={`caret ${sortDir} icon`} />
              {label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
